<template>
  <AppModalEdit
    v-model="isShowing"
    title="メニュー追加申請"
    :loading="loading"
    @clickExec="save"
  >
    <v-container v-if="item != null" grid-list-md>
      <v-layout>
        <v-flex xs2>
          メニュー使用可能範囲
        </v-flex>
        <v-flex xs10>
          {{ item.scopeString }}
        </v-flex>
      </v-layout>
      <v-layout pt-2>
        <v-flex xs2>
          適用広告主
        </v-flex>
        <v-flex xs10>
          {{ item.scope }}
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2>
          メニュー種類
        </v-flex>
        <v-flex xs10>
          {{ item.menuTypeString }}
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2>
          メニュー名
        </v-flex>
        <v-flex xs10>
          {{ item.name }}
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2>
          メニュー説明
        </v-flex>
        <v-flex xs10>
          {{ item.description }}
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2>
          課金形態
        </v-flex>
        <v-flex xs10>
          {{ item.unitTypeUpperCase }}
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2>
          配信単価
        </v-flex>
        <v-flex xs10>
          <AppCurrency :value="item.displayData.unitPrice" />
        </v-flex>
      </v-layout>
      <DateRangePicker
        :default-use-date-range="item.useDateRange"
        :start="startDate"
        :end="endDate"
        label="使用可能期間"
        uselabel="期間を指定する"
        not-uselabel="期間を指定しない"
        @change="changeDateRange"
      />
    </v-container>
  </AppModalEdit>
</template>

<script>
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import DateRangePicker from '@/components/Shared/CrudUI/DateRangePicker'
export default {
  components: { DateRangePicker },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      loading: false,
    }
  },
  computed: {
    isShowing: {
      get() {
        return this.value
      },
      set(isDisplay) {
        return this.$emit('input', isDisplay)
      },
    },
  },
  watch: {
    value(val) {
      if (!val) return
      this.startDate = this.item.startDate
      this.endDate = this.item.endDate
    },
  },
  methods: {
    changeDateRange(obj) {
      const start = obj.useDateRange ? obj.startDate : ''
      const end = obj.useDateRange ? obj.endDate : ''
      this.startDate = start
      this.endDate = end
    },
    async save() {
      this.loading = true
      try {
        await this.item.requestEdit({
          start: this.startDate,
          end: this.endDate,
        })
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '申請完了しました',
        })
      } catch (e) {
        this.loading = false
        const error = new Error('保存に失敗しました。')
        throw error
      }
      this.loading = false
      this.$emit('save', false)
    },
  },
}
</script>

<style></style>
